<template>
    <label class="cb-primary">
        <input type="checkbox" class="form-input" :checked="checked" />
        <small @click="clicked()"></small>
    </label>
</template>

<script>
export default {
    props: {
        click: {
            required: false,
            type: Function
        },

        checked: {
            required: true,
            type: Boolean
        }
    },

    methods: {
        clicked() {
            if(this.click) {
                this.click();
            }
        }
    }
}
</script>

<style lang="scss">
.cb-primary {
    input {
        display: none;
    }
}
</style>